// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"478":"eb01a38b","525":"9f463b49"}[chunkId] + ".css";
};